import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import {
  isExamSubmittedByHead,
  submitApi,
  submitWarning,
  saveOptions,
} from "../../services/service";
import { useAttemptedQuestions } from "../../context/AttemptedQuestionsContext";
import { leftTime } from "../../components/TimerComponent";
import socket from "../../socket/socket";
import ROUTES_NAME from "../../constants/RoutesName";
import { decryptData } from "../../crypto";
import { useQuestionRecord } from "../../context/QuestionRecord";
import { useOptionRecord } from "../../context/OptionRecord";
import { useQuestionNavigator } from "./useQuestionNavigator";
import { encryptData } from "../../crypto";

export const useQuestionSection = ({
  questionData,
  currentQuestion,
  setCurrentQuestion,
  subjectId,
}) => {
  const [selectedOptionId, setSelectedOptionId] = useState(null);
  const [selectedOptionIds, setSelectedOptionIds] = useState([]);
  const [inputAnswer, setInputAnswer] = useState("");
  const [showSubmissionPopup, setShowSubmissionPopup] = useState(false);
  const [showSubmissionPopupReLogin, setShowSubmissionPopupReLogin] =
    useState(false);
  const [showServerErrorDialog, setShowServerErrorDialog] = useState(false);
  const [showSubmitModal, setShowSubmitModal] = useState(false);
  const [isTimeUp, setIsTimeUp] = useState(false);
  const [countdownTime, setCountdownTime] = useState(10);
  const [finalSubmitChecked, setFinalSubmitChecked] = useState(false);
  const [submitError, setSubmitError] = useState("");
  const [countdownByHead, setCountdownByHead] = useState(0);
  const [stats, setStats] = useState({
    totalQuestions: "",
    notViewedQ: "",
    attemptedWithAnswered: "",
    attemptedWithoutAnswered: "",
    markedWithAnswered: "",
    markedWithotAnswered: "",
  });

  const navigate = useNavigate();
  const { attemptedQuestions, fetchAttemptedQuestions } =
    useAttemptedQuestions();
  const { addQuestionRecord, questionRecords, getQuestionRecordById } =
    useQuestionRecord();
  const { addOptionRecord, optionRecords, deleteOptionRecord } =
    useOptionRecord();
  const {
    answered,
    marked,
    notVisited,
    notAnswered,
    markedWithAnswered,
    visitedQuestions,
  } = useQuestionNavigator({ questionData, currentQuestion });

  const question = questionData ? questionData[currentQuestion] : {};
  const timerRef = useRef(null);

  useEffect(() => {
    if (questionData) {
      if (
        getQuestionRecordById(question?.id)?.attempt_status ===
          "not answered" ||
        getQuestionRecordById(question?.id)?.attempt_status === "" ||
        // question?.status === "marked" ||
        getQuestionRecordById(questionData[currentQuestion]?.id)
          ?.attempt_status === undefined
      ) {
        handleOptions();
      }
    }
  }, [selectedOptionId, selectedOptionIds, inputAnswer]);

  // useEffect(() => {
  //   const fetchData = async (currentQuestion) => {
  //     try {
  //       const examId = sessionStorage.getItem("examId");
  //       const currentQuestionId = questionData?.[currentQuestion]?.id;
  //       const currentQuestionType = questionData?.[currentQuestion]?.type;

  //       if (!currentQuestionId) return;

  //       const q = questionRecords.find(
  //         (q) => Number(q?.question_id) === Number(currentQuestionId)
  //       );

  //       const ans =
  //         q?.answer ||
  //         q?.option_id ||
  //         q?.multiple_option_ids ||
  //         currentQuestionType === "Multiple Choice"
  //           ? []
  //           : null;

  //       const data = {
  //         attempt_status: "",
  //         exam_id: examId,
  //         option_id: ans,
  //         question_id: String(currentQuestionId),
  //         remaining_time: leftTime,
  //         subject_id: questionData[currentQuestion]?.subject_id,
  //       };

  //       const response = await saveOptions(data);
  //       if (response) {
  //         addQuestionRecord(data);
  //       }
  //     } catch (error) {
  //       console.error("Error saving question status:", error);
  //     }
  //   };

  //   if (questionData?.[currentQuestion]?.id) {
  //     const questionRecord = getQuestionRecordById(
  //       questionData[currentQuestion].id
  //     );
  //     const needsInitialSave =
  //       !questionRecord || questionRecord.attempt_status === "not answered";

  //     if (needsInitialSave) {
  //       fetchData();
  //     }
  //   }
  // }, []);

  useEffect(() => {
    if (question?.id) {
      const questionRecord = getQuestionRecordById(question?.id);
      if (questionRecord?.attempt_status === "attempted") {
        deleteOptionRecord(questionRecord?.question_id);
      }
    }
  }, [question]);

  // Load previously selected option if already attempted
  useEffect(() => {
    if (question?.id) {
      let attempted =
        optionRecords?.find((aq) => Number(aq.question_id) === question?.id) ||
        null;

      if (!attempted) {
        attempted =
          questionRecords?.find(
            (aq) => Number(aq?.question_id) === Number(question?.id)
          ) || [];
      }

      if (question?.question_type === "Multiple Choice") {
        setSelectedOptionIds(attempted?.multiple_option_ids || []);
      } else if (question?.question_type === "Fill In The Blanks") {
        setInputAnswer(attempted?.answer || "");
      } else {
        setSelectedOptionId(attempted?.option_id || null);
      }
    }
  }, [currentQuestion, question, questionRecords]);

  useEffect(() => {
    const examId = sessionStorage.getItem("examId");
    if (isTimeUp) {
      submitWarningAPI(examId);
      setShowSubmitModal(true);
      const timer = setInterval(() => {
        setCountdownTime((prevTime) => prevTime - 1);
      }, 1000);

      const timeout = setTimeout(() => {
        clearInterval(timer);
        handleFinalSubmit();
        // sessionStorage.clear();
        // navigate(ROUTES_NAME.LOGIN);
      }, 10000);

      return () => {
        clearTimeout(timeout);
        clearInterval(timer);
      };
    }
  }, [isTimeUp]);

  const resetSelections = () => {
    setSelectedOptionId(null);
    setSelectedOptionIds([]);
    setInputAnswer("");
    // deleteOptionRecord(question?.)
  };

  const navigateBasedOnStateBySubmissionOfHead = (examResult) => {
    const currentInstantResultState =
      sessionStorage.getItem("examInstantResult");
    if (currentInstantResultState === "no") {
      navigate(ROUTES_NAME.THANK_YOU);
    } else {
      navigate(ROUTES_NAME.EXAM_SCORE, { state: { examResult } });
    }
  };

  const submitWarningAPI = async (examId) => {
    try {
      const submitWarningData = await submitWarning(examId);
      setStats({
        totalQuestions: submitWarningData.totalQuestions,
        notViewedQ: submitWarningData.notViwed,
        attemptedWithAnswered: submitWarningData.attemptedWithAnswered,
        attemptedWithoutAnswered: submitWarningData.attemptedWithoutAnswered,
        markedWithAnswered: submitWarningData.markedWithAnswered,
        markedWithotAnswered: submitWarningData.markedWithotAnswered,
      });
    } catch (error) {
      console.error("Error fetching questions:", error);
    }
    // setStats({
    //   totalQuestions: questionData?.length,
    //   notViewedQ: notVisited,
    //   attemptedWithAnswered: answered,
    //   attemptedWithoutAnswered: notAnswered,
    //   markedWithAnswered: markedWithAnswered,
    //   markedWithotAnswered: marked,
    // });
  };

  const isExamSubmittedByHeadCheck = async () => {
    const examId = sessionStorage.getItem("examId");
    submitWarningAPI(examId);
    try {
      // const response = await isExamSubmittedByHead(examId);
      // if (response.status) {
      setShowSubmissionPopup(true);
      sessionStorage.setItem("submitByH", true);
      let timer = 10;
      const countdownInterval = setInterval(() => {
        setCountdownByHead(timer);
        if (timer === 1) {
          clearInterval(countdownInterval);
          setShowSubmissionPopup(false);

          const branch_id = sessionStorage.getItem("selectedBranch");
          const center_id = sessionStorage.getItem("selectedCenter");
          const userAuth = JSON.parse(sessionStorage.getItem("userAuth"));
          const exam_name = decryptData(sessionStorage.getItem("exam_name"));
          sessionStorage.clear();
          sessionStorage.setItem("exam_name", encryptData(exam_name));
          sessionStorage.setItem("selectedBranch", branch_id);
          sessionStorage.setItem("selectedCenter", center_id);
          sessionStorage.setItem("userAuth", JSON.stringify(userAuth));
          sessionStorage.setItem("candidateLoggedinToDashboard", true);
          navigate(ROUTES_NAME.THANK_YOU);

          // navigateBasedOnStateBySubmissionOfHead(response.examResult);
          // sessionStorage.clear();
        }
        timer--;
      }, 1000);
      // }
    } catch (error) {
      console.error("Error submitting exam:", error);
      setSubmitError(error.response?.data.message || "Unknown error");
    }
  };

  const handleFinalSubmit = async () => {
    const examId = sessionStorage.getItem("examId");
    try {
      const response = await submitApi({ examId });
      if (response.success === false) {
        setShowServerErrorDialog(true);
        return;
      }
      if (response.success) {
        setShowSubmitModal(false);
        const examId = sessionStorage.getItem("examId");
        const userId = sessionStorage.getItem("userId");
        socket.emit("changeStatus", {
          examId,
          userId,
          status: "Submitted",
        });
        navigateBasedOnStateBySubmissionOfHead(response.examResult);
        // sessionStorage.clear();
      }
    } catch (error) {
      console.error("Error submitting exam:", error);
      setSubmitError(error.response?.data.message || "Unknown error");
    }
  };

  const handleSaveNext = async () => {
    // await isExamSubmittedByHeadCheck();
    const examId = sessionStorage.getItem("examId");
    const isMultipleChoice = question?.question_type === "Multiple Choice";
    const isInputType = question?.question_type === "Fill In The Blanks";

    let option_id_to_save = isMultipleChoice
      ? selectedOptionIds
      : isInputType
      ? inputAnswer
      : selectedOptionId;

    if (!option_id_to_save || option_id_to_save?.length === 0) {
      if (isInputType) {
        alert("Please enter your answer");
      } else {
        alert("Please select a option");
      }
      return;
    }

    const data = {
      attempt_status: "attempted",
      exam_id: examId,
      option_id: option_id_to_save,
      question_id: String(question?.id),
      remaining_time: leftTime,
      subject_id: subjectId,
    };
    //
    try {
      const response = await saveOptions(data);
      if (response.success === false) {
        setShowServerErrorDialog(true);
        return;
      }
      if (response) {
        // fetchAttemptedQuestions(examId);
        addQuestionRecord({
          ...data,
          question_id: Number(question?.id),
          option_id: option_id_to_save,
          answer: isInputType ? option_id_to_save : null,
          multiple_option_ids: isMultipleChoice ? option_id_to_save : null,
        });
        deleteOptionRecord(question?.id);
        // resetSelections();
        // Only move to next question if not on last question
        if (currentQuestion < questionData?.length - 1) {
          setCurrentQuestion(currentQuestion + 1);
          fetchData(currentQuestion + 1);
        }
      }
    } catch (error) {
      console.log(error);
    }
  };
  const handleSaveNextDefault = async () => {
    // await isExamSubmittedByHeadCheck();
    const examId = sessionStorage.getItem("examId");
    const isMultipleChoice = question?.question_type === "Multiple Choice";
    const isInputType = question?.question_type === "Fill In The Blanks";

    let option_id_to_save = isMultipleChoice
      ? selectedOptionIds
      : isInputType
      ? inputAnswer
      : selectedOptionId;

    const data = {
      attempt_status: option_id_to_save ? "attempted" : "",
      exam_id: examId,
      option_id: option_id_to_save,
      question_id: question?.id,
      remaining_time: leftTime,
      subject_id: subjectId,
    };

    try {
      const response = await saveOptions(data);
      if (response.success === false) {
        setShowServerErrorDialog(true);
        return;
      }
      if (response) {
        resetSelections();
        fetchAttemptedQuestions(examId);
        // Only move to next question if not on last question
        if (currentQuestion < questionData?.length - 1) {
          setCurrentQuestion(currentQuestion + 1);
        } else if (
          currentQuestion === questionData?.length - 1 &&
          decryptData(sessionStorage.getItem("exam_template")) === "ssc/railway"
        ) {
          setCurrentQuestion(0);
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  // Other handler functions (handleMarkReview, handleClearResponse, handleBack, handleNext)
  // would follow the same pattern...
  const handleNext = () => {
    // isExamSubmittedByHeadCheck();
    if (currentQuestion < questionData?.length - 1) {
      setCurrentQuestion(currentQuestion + 1);
      resetSelections();
    }
  };

  const fetchData = async (currentQuestion) => {
    if (questionData?.[currentQuestion]?.id) {
      const questionRecord = getQuestionRecordById(
        questionData[currentQuestion].id
      );
      const needsInitialSave =
        !questionRecord || questionRecord.attempt_status === "not answered";

      if (needsInitialSave) {
        try {
          const examId = sessionStorage.getItem("examId");
          const currentQuestionId = questionData?.[currentQuestion]?.id;
          const currentQuestionType =
            questionData?.[currentQuestion]?.question_type;

          if (!currentQuestionId) return;

          // const q = questionRecords.find(
          //   (q) => Number(q?.question_id) === Number(currentQuestionId)
          // );
          const q = getQuestionRecordById(currentQuestionId);

          const ans =
            q?.answer ||
            q?.option_id ||
            q?.multiple_option_ids ||
            currentQuestionType === "Multiple Choice"
              ? []
              : null;

          const data = {
            attempt_status: "",
            exam_id: examId,
            option_id: ans,
            question_id: String(currentQuestionId),
            remaining_time: leftTime,
            subject_id: questionData[currentQuestion]?.subject_id,
          };

          const response = await saveOptions(data);
          if (response.success === false) {
            setShowServerErrorDialog(true);
            return;
          }
          if (response) {
            addQuestionRecord(data);
          }
        } catch (error) {
          console.error("Error saving question status:", error);
        }
      }
    }
  };

  const handleNextIit = async () => {
    if (currentQuestion < questionData?.length - 1) {
      setCurrentQuestion(currentQuestion + 1);
      if (questionData?.[currentQuestion + 1]?.id) {
        const questionRecord = getQuestionRecordById(
          questionData[currentQuestion + 1].id
        );
        const needsInitialSave =
          !questionRecord || questionRecord.attempt_status === "not answered";

        if (needsInitialSave) {
          fetchData(currentQuestion + 1);
        }
      }
    }
  };

  const handleMarkReview = async (status, showAlert = false, blank = false) => {
    // isExamSubmittedByHeadCheck();
    const examId = sessionStorage.getItem("examId");
    const isMultipleChoice = question?.question_type === "Multiple Choice";
    const isInputType = question?.question_type === "Fill In The Blanks";

    let option_id_to_save = isMultipleChoice
      ? selectedOptionIds
      : isInputType
      ? inputAnswer
      : selectedOptionId;

    if (blank) {
      resetSelections();
      deleteOptionRecord(question?.id);
    }

    if ((!option_id_to_save || option_id_to_save?.length === 0) && showAlert) {
      isInputType
        ? alert("Please enter your answer")
        : alert("Please select a option");
      return;
    }

    if (!showAlert) {
      option_id_to_save = null;
    }
    if (!showAlert && isMultipleChoice) {
      option_id_to_save = [];
    }

    const data = {
      attempt_status: status,
      exam_id: examId,
      option_id: option_id_to_save,
      question_id: String(question?.id),
      remaining_time: leftTime,
      subject_id: subjectId,
    };

    try {
      const response = await saveOptions(data);
      if (response.success === false) {
        setShowServerErrorDialog(true);
        return;
      }
      if (response) {
        // fetchAttemptedQuestions(examId);
        addQuestionRecord({
          ...data,
          question_id: Number(question?.id),
          option_id: isMultipleChoice ? null : option_id_to_save,
          answer: isInputType ? option_id_to_save : null,
          multiple_option_ids: isMultipleChoice ? option_id_to_save : null,
        });
        deleteOptionRecord(question?.id);
        // resetSelections();
        // Only move to next question if not on last question
        if (currentQuestion < questionData?.length - 1) {
          setCurrentQuestion(currentQuestion + 1);
          fetchData(currentQuestion + 1);
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleMarkReviewDefault = async (status) => {
    // isExamSubmittedByHeadCheck();
    const examId = sessionStorage.getItem("examId");
    const isMultipleChoice = question?.question_type === "Multiple Choice";
    const isInputType = question?.question_type === "Fill In The Blanks";

    let option_id_to_save = isMultipleChoice
      ? selectedOptionIds
      : isInputType
      ? inputAnswer
      : selectedOptionId;

    const data = {
      attempt_status: status,
      exam_id: examId,
      option_id: option_id_to_save,
      question_id: question?.id,
      remaining_time: leftTime,
      subject_id: subjectId,
    };

    try {
      const response = await saveOptions(data);
      if (response.success === false) {
        setShowServerErrorDialog(true);
        return;
      }
      if (response) {
        resetSelections();
        fetchAttemptedQuestions(examId);
        // Only move to next question if not on last question
        if (currentQuestion < questionData?.length - 1) {
          setCurrentQuestion(currentQuestion + 1);
        } else if (
          currentQuestion === questionData?.length - 1 &&
          decryptData(sessionStorage.getItem("exam_template")) === "ssc/railway"
        ) {
          setCurrentQuestion(0);
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleClearResponse = () => {
    // isExamSubmittedByHeadCheck();
    resetSelections();
  };
  const handleBack = () => {
    // isExamSubmittedByHeadCheck();
    if (currentQuestion > 0) {
      setCurrentQuestion(currentQuestion - 1);
      resetSelections();
    }
  };

  const handleButtonClick = async (idx, id) => {
    setCurrentQuestion(idx);
    if (questionData?.[idx]?.id) {
      const questionRecord = getQuestionRecordById(questionData[idx].id);
      const needsInitialSave =
        !questionRecord || questionRecord.attempt_status === "not answered";

      if (needsInitialSave) {
        fetchData(idx);
      }
    }
  };

  const handleBackIit = async () => {
    // // isExamSubmittedByHeadCheck();
    if (currentQuestion > 0) {
      setCurrentQuestion(currentQuestion - 1);
      if (questionData?.[currentQuestion - 1]?.id) {
        const questionRecord = getQuestionRecordById(
          questionData[currentQuestion - 1].id
        );
        const needsInitialSave =
          !questionRecord || questionRecord.attempt_status === "not answered";

        if (needsInitialSave) {
          fetchData(currentQuestion - 1);
        }
      }
      // resetSelections();
    }
  };
  const handleOptions = () => {
    if (!question) return;
    const examId = sessionStorage.getItem("examId");
    const isMultipleChoice = question?.question_type === "Multiple Choice";
    const isInputType = question?.question_type === "Fill In The Blanks";

    const storedQuestion = getQuestionRecordById(question?.id);

    let option_id_to_save = isMultipleChoice
      ? selectedOptionIds
      : isInputType
      ? inputAnswer
      : selectedOptionId;

    // Determine attempt status based on current selection
    let attempt_status = storedQuestion?.attempt_status || "not answered";

    // If there's a selection, update status to "attempted"
    // if (
    //   (isMultipleChoice && selectedOptionIds.length > 0) ||
    //   (isInputType && inputAnswer) ||
    //   (!isMultipleChoice && !isInputType && selectedOptionId !== null)
    // ) {
    //   attempt_status = "attempted";
    // }

    const data = {
      attempt_status,
      exam_id: examId,
      option_id: !isMultipleChoice && !isInputType ? option_id_to_save : null,
      answer: isInputType ? option_id_to_save : null,
      multiple_option_ids: isMultipleChoice ? option_id_to_save : [],
      remaining_time: leftTime,
      subject_id: subjectId,
      question_id: question?.id,
    };
    addOptionRecord(data);
  };

  useEffect(() => {
    socket.connect();
    const user = sessionStorage.getItem("userId");
    const exam = sessionStorage.getItem("examId");

    const startCountdown = () => {
      setShowSubmissionPopupReLogin(true);
      sessionStorage.setItem("relogin", true);
      let timer = 5;
      timerRef.current = setInterval(() => {
        setCountdownByHead(timer);
        if (timer === 1) {
          sessionStorage.clear();
          clearInterval(timerRef.current);
          setShowSubmissionPopupReLogin(false);
          navigate(ROUTES_NAME.LOGIN);
          window.location.reload();
        }
        timer--;
      }, 1000);
    };

    const handleExamSubmit = ({ examId, userId }) => {
      if (String(userId) === user && String(examId) === exam)
        isExamSubmittedByHeadCheck();
    };

    const handleExamSubmitAll = ({ examId }) => {
      if (String(examId) === exam) isExamSubmittedByHeadCheck();
    };

    const handleReLogin = ({ examId, userId }) => {
      if (userId === sessionStorage.getItem("userId") && examId === exam)
        startCountdown();
    };

    const handleReLoginAll = ({ examId }) => {
      if (examId === exam) startCountdown();
    };

    const selectedLogout = ({ learnerIds }) => {
      if (learnerIds.map(String).includes(user)) {
        startCountdown();
      }
    };

    // socket.on("exam_submit_check", handleExamSubmit);
    // socket.on("exam_submit_check_all", handleExamSubmitAll);
    socket.on("re_login", handleReLogin);
    socket.on("re_login_all", handleReLoginAll);
    socket.on("selected_logout", selectedLogout);

    if (sessionStorage.getItem("relogin")) {
      sessionStorage.clear();
      navigate(ROUTES_NAME.LOGIN);
      window.location.reload();
    }

    if (sessionStorage.getItem("submitByH")) {
      isExamSubmittedByHeadCheck();
    }

    return () => {
      socket.off("exam_submit_check", handleExamSubmit);
      socket.off("exam_submit_check_all", handleExamSubmitAll);
      socket.off("re_login", handleReLogin);
      socket.off("re_login_all", handleReLoginAll);
      socket.off("selected_logout", selectedLogout);

      if (timerRef.current) {
        clearInterval(timerRef.current);
      }

      socket.disconnect();
    };
  }, []);

  return {
    selectedOptionId,
    selectedOptionIds,
    inputAnswer,
    showSubmissionPopup,
    showSubmissionPopupReLogin,
    showServerErrorDialog,
    setShowServerErrorDialog,
    showSubmitModal,
    isTimeUp,
    countdownTime,
    finalSubmitChecked,
    submitError,
    countdownByHead,
    stats,
    handleOptionChange: (event) => {
      setSelectedOptionId(Number(event.target.value));
      // handleOptions();
    },

    handleMultipleChoiceChange: (event, id) => {
      if (event.target.checked) {
        setSelectedOptionIds((prev) => [...prev, id]);
        // handleOptions();
      } else {
        setSelectedOptionIds((prev) =>
          prev.filter((optionId) => optionId !== id)
        );
        // handleOptions();
      }
    },
    handleInputChange: (event) => {
      setInputAnswer(event.target.value);
      // handleOptions();
    },
    resetSelections,
    handleSaveNext,
    handleSaveNextDefault,
    handleMarkReview,
    handleMarkReviewDefault,
    handleClearResponse,
    handleBack,
    handleNext,
    handleOpenSubmitModal: () => {
      setShowSubmitModal(true);
      const examId = sessionStorage.getItem("examId");
      if (examId) submitWarningAPI(examId);
    },
    handleCloseSubmitModal: () => setShowSubmitModal(false),
    handleFinalSubmitCheck: () => setFinalSubmitChecked(!finalSubmitChecked),
    handleFinalSubmit,
    setIsTimeUp,
    handleNextIit,
    handleBackIit,
    handleButtonClick,
    fetchData,
  };
};
